import {
    AUTH_LOGOUT,
    NOTIFICATION_ADD,
    NOTIFICATION_REMOVE,
} from '../actions';
import Vue from 'vue';

const state = {
    items: [],
};

const getters = {
    getNotifications: state => state.items,
};

const actions = {
    [NOTIFICATION_ADD]: (context, item) => {
        if (!item.timeout) {
            item.timeout = 300000 + new Date().getTime();
        }
        context.commit(NOTIFICATION_ADD, item);
    },
    [NOTIFICATION_REMOVE]: (context, item) => {
        context.commit(NOTIFICATION_REMOVE, item);
    },
    [AUTH_LOGOUT]: (context) => {
        context.commit(AUTH_LOGOUT);
    },
};

const mutations = {
    [NOTIFICATION_ADD]: (state, item) => {
        for (let i = 0; i < state.items.length; i++) {
            if (state.items[i].event_id == item.event_id) {
                return;
            }
        }
        state.items.push(item);
    },
    [NOTIFICATION_REMOVE]: (state, idx) => {
        state.items.splice(idx, 1);
    },
    [AUTH_LOGOUT]: (state) => {
        console.info('Clearing notifications from store at AUTH_LOGOUT.');
        state.items = [];
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
